<template>
  <div id="fh5co-wrapper">
    <div id="fh5co-page">
      <Header></Header>
      <div
        class="fh5co-cover main-vis"
        data-stellar-background-ratio="0.5"
        style="background-image: url(/static/main_corp.jpg)"
      >
      </div>
      <div class="heading-section text-center animate-box mt-2">
        <span>
          <a class="btn btn-border btn-large btn-trx" href="https://legame.atelier-joe.jp/" target="_blank" rel="noopener noreferrer">会員の方はコチラ</a>
        </span>
      </div>
      <div class="text-center menu-container">
        <div class="change-cycle">
          <p class="corporate-msg">
          仕事への活力は健康に大いに関わってきます。<br />
          しかし、日本全国で健康経営に取り組んでいる企業様は約50%と言われており、コロナ禍からはじまった在宅ワークテレワークの影響で歩く機会も減り、企業としても社員様の健康をより心配する声も多く聞きます。<br />

          実際のデータからも、2020年2月以降、メンタル不調者増は26.5% 、身体的不調者増は22.7%となっております。<br />

          そんな状況を見て、我々は社員の健康を守りたい企業様へ、福利厚生として健康へのアプローチ方法をご提案いたします。<br />

          <small>データ参照元：株式会社月刊総務</small>
          </p>
          <img src="/static/corporation/ng.png" alt="">

          <p class="corporate-msg">
          例えば、デスクワークで身体を動かす時間が減ってしまい、よくある症状で見られるのが「肩こり」・「腰痛」です。<br />

          「肩こり」・「腰痛」が起きるということは、身体が正常な姿勢ではなくなってしまっていると言えます。<br />
          図のように悪循環がどんどん進行していきます。<br />

          しかし、肩こりや腰痛が改善すると、心身共に善の循環に変化していき、働くパフォーマンス向上に繋がるのはもちろん、プライベート含め、健康は人生を豊かにしていきます。<br />
          </p>
          <img src="/static/corporation/arrow_below.png" alt=""  class="change-cycle-img-allow">
          <img src="/static/corporation/ok.png" alt="">
        </div>
        <div class="heading-feature text-center">
          企業に健康を届け隊 3つの魅力
        </div>
        <div class="pos-rel mt-2 fh5co-lightgray-section">
          <div class="container">
            <div class="row">
              <div class="col-md-5 col-md-offset-2">
                <h1 class="heading-solid1 text-center mt-2">
                  肩こり・腰痛改善などの健康改善コンテンツ
                </h1>
                <p class="mt-2 text-left">
                  運動＝筋トレや走ることだけではありません。デスクに座りながらできる、肩こり・腰痛の改善運動や、ストレッチ動画も豊富にございます。
                </p>
              </div>
              <div class="col-md-3">
                <div class="row text-center feature1-image-container mt-2">
                  <div class="col-md-12 col-sm-6">
                    <img
                      src="/static/feature01.jpg"
                      alt="Legame Online の魅力１ 動画でトレーニング"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2">
          <div class="container">
            <div class="row">
              <div class="col-md-5 col-md-push-5 col">
                <h1 class="heading-solid1 text-center mt-2">
                  日々の生活に活力となる運動コンテンツ
                </h1>
                <p class="mt-2 text-left">
                  筋トレ、短期ダイエットコース、ダンス、ヨガなど、家でも運動できるコンテンツを豊富にご用意しております。
                </p>
              </div>
              <div class="col-md-3 col-md-pull-5 col-md-offset-2 col">
                <div class="row text-center feature1-image-container mt-2">
                  <div class="col-md-12 col-sm-12">
                    <img
                      src="/static/feature02smp_1.jpg"
                      alt="トレーニング診断アプリ メニュー選択画面"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2 fh5co-lightgray-section">
          <div class="container">
            <div class="row">
              <div class="col-md-5 col-md-offset-2 col">
                <h1 class="heading-solid1 text-center mt-2">
                  管理栄養士による食事レシピ公開中
                </h1>
                <p class="mt-2 text-left">
                  カロリー別に検索できるレシピを公開中<br />
                  ショート動画もご用意しております
                </p>
              </div>
              <div class="col-md-3 col">
                <div class="row text-center feature1-image-container mt-2">
                  <div class="col-md-12 col-sm-12">
                    <img
                      src="/static/feature02_book.jpg"
                      alt="トレーニング診断アプリ トレーニング動画一覧画面"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="heading-section text-center animate-box mt-2">
        <span>
          <a class="btn btn-border btn-large btn-trx" href="https://coubic.com/legame/products#pageContent" target="_blank" rel="noopener noreferrer">お申込みはコチラ</a>
        </span>
      </div>
      <MovieSample />
      <Media />
      <PriceCorporate />
      <div class="heading-section text-center animate-box mt-2">
        <span>
          <a class="btn btn-border btn-large btn-trx" href="https://coubic.com/legame/products#pageContent" target="_blank" rel="noopener noreferrer">お申込みはコチラ</a>
        </span>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue'
import Footer from './Footer.vue'
import PriceCorporate from './PriceCorporate.vue'
import Media from './Media.vue'
import AppDownload from './AppDownload.vue'
import MovieSample from './MovieSample.vue'

export default {
  name: 'Menu',
  components: {
    Header,
    PriceCorporate,
    Media,
    AppDownload,
    MovieSample,
    Footer
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-vis {
  height: 56vw;
  background-repeat: no-repeat;
  background-position: center top;
  background-size: contain;
}
.corporate-msg{
  font-size: 14px;
  text-align: left;
  background-color: #fffff3;
  padding: 20px 30px;
}
.change-cycle{
  padding: 20px;
  text-align: center;
}
  .change-cycle img{
    width: 85%
  }
  .change-cycle .change-cycle-img-allow{
    width: 15%;
    margin: 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Corporation.vue